import React, {useLayoutEffect, useRef} from 'react'
import {Lang} from 'yougile-lang'
import {Tracking, TrackingEvent} from '@common/tracking'
import {CheckboxNew} from '@components/common/base/checkbox-new/checkbox-new'
import {CommonProps} from '@components/sticker/my-stickers/board-stickers/sticker-settings/sticker-settings-content'
import {TwSetting} from '../containers'
import {useCommonHandlers} from '../use-common-handlers'

export const DeadlineStickerSettingsContent = (props: CommonProps) => {
  const {state, sticker, setState} = props
  const {toggleHasDefaultState} = useCommonHandlers(sticker, setState)

  const firstUpdate = useRef(true)
  useLayoutEffect(() => {
    if (firstUpdate.current) {
      firstUpdate.current = false
      return
    }
    state.hasDefaultState
      ? void Tracking.send(TrackingEvent.stickerSettingsShowTimerView_Enable)
      : void Tracking.send(TrackingEvent.stickerSettingsShowTimerView_Disable)
  }, [state.hasDefaultState])

  return (
    <TwSetting>
      <CheckboxNew
        className="py-8"
        value={state.hasDefaultState ?? false}
        onChange={toggleHasDefaultState}
        label={Lang.msg.myStickers.displayAsTimer}
      />
    </TwSetting>
  )
}
